<template>
  <div class="resetPwd">
    <div class="title">设置密码</div>
    <van-form @submit="onSubmit">
      <van-field
        v-model.trim="newPassword"
        type="password"
        name="password"
        placeholder="至少输入6位新密码"
        :rules="[{message: '请填写至少六位的密码', validator: value => value.length >= 6}]"
      />
      <van-field
        v-model.trim="password"
        type="password"
        name="password"
        placeholder="请再次输入新密码"
        :rules="[{message: '请填写至少六位的密码', validator: value => value.length >= 6}]"
      />
      <div style="margin-top: 40px;">
        <van-button round block type="info" native-type="submit">
          完 成
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import {setNewPwd} from '@/api'
export default {
  data() {
    return {
      newPassword: '',
      password: '',
      verifyId: ''
    }
  },
  created() {
    this.verifyId = this.$route.query.verifyId
  },
  methods: {
    onSubmit() {
      if (this.newPassword === this.password) {
        const params = {
          verifyId: this.verifyId,
          newPassword: this.newPassword
        }
        setNewPwd(params).then(res => {
          this.$router.push({
            path: '/success',
            query: {type: 1}
          })
        })
      } else {
        return this.$Toast.fail('两次输入密码不相等')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.resetPwd {
  height: 100vh;
  background: #fff;
  padding: 20px;
}
.title {
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 700;
}
</style>
